"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.pickKeys = void 0;
const ramda_1 = require("ramda");
/**
 * Create an object by picking some of its keys
 * @public
 *
 * @typeParam T - The input type of the object
 * @typeParam TOut - The output object with the specified keys
 *
 * @param object - The object to be transformed by picking some keys
 * @param keys - The keys to pick
 *
 * @returns A new copy of the object only with the keys specified
 *
 * @example
 * ```ts
 * const coolObject = pickKeys({status: 'amICool', option1: 'yes', option2: 'no'}, 'status', 'option1'); // {status: 'amICool', option1: 'yes'}
 * ```
 */
function pickKeys(object, ...keys) {
    return (0, ramda_1.pick)(keys, object);
}
exports.pickKeys = pickKeys;
//# sourceMappingURL=pick-keys.js.map